import { UnlockChatMessageAttachmentDefinition } from "@super-real/types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const unlockChatMessageAttachmentCallable = getCallable(
  UnlockChatMessageAttachmentDefinition
);
